var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 22.75C16.792 18.85 20.5837 15.3578 20.5837 11.05C20.5837 6.74218 17.1885 3.25 13.0003 3.25C8.81217 3.25 5.41699 6.74218 5.41699 11.05C5.41699 15.3578 9.20866 18.85 13.0003 22.75Z",
    stroke: "#434CE5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 14.0833C14.7953 14.0833 16.2503 12.6283 16.2503 10.8333C16.2503 9.03841 14.7953 7.58333 13.0003 7.58333C11.2054 7.58333 9.75033 9.03841 9.75033 10.8333C9.75033 12.6283 11.2054 14.0833 13.0003 14.0833Z",
    stroke: "#434CE5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.3113c63d941f1fed46b258e7a9566af7.svg";
export { ForwardRef as ReactComponent };